import ViewViewModel from '@/ViewModels/ViewViewModel';
import ComponentManager from '@/Management/ComponentManager';
import RADApplication from '@/Management/RADApplication';
import * as CoreFrameInterfaces from '#/CoreFrameInterfaces';
import GlobalConfiguration from '@/Management/GlobalConfiguration';

import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import WindowViewModelT from '@/ViewModels/Controls/WindowViewModel';
import ButtonViewModelT from '@/ViewModels/Controls/ButtonViewModel';
import DropDownListViewModelT from '@/ViewModels/Controls/DropDownListViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';

export default class TemplateStyleViewModel extends ViewViewModel {

    private WindowViewModel = ComponentManager.getViewModel<typeof WindowViewModelT>('WindowViewModel');
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
    private ButtonViewModel = ComponentManager.getViewModel<typeof ButtonViewModelT>('ButtonViewModel');
    private DropDownListViewModel = ComponentManager.getViewModel<typeof DropDownListViewModelT>('DropDownListViewModel');
    private ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');

    public onClose: Function;
    public window: WindowViewModelT;
    public templateStyle: DropDownListViewModelT;
    public okay: ButtonViewModelT;
    public cancel: ButtonViewModelT;

    public constructor(private params: CoreFrameInterfaces.TemplateStyleViewModelConstructorParameter) {
        super(params);

        /**
         * Handler für das Schließen des Fensters
         */
        this.onClose = this.handlerOrDefault(params.onClose);

        this.window = new this.WindowViewModel({
            isModal: true,
            isOpen: true,
            allowClose: true,
            headline: new this.LabelViewModel({
                ergName: 'RAD.RADFOUNDATION.PROBLEMDOMAIN.META.PDAPPLICATIONMETA_TEMPLATESTYLE_ERGNAME'
            }),
            onClose: this.onClose
        });

        this.templateStyle = new this.DropDownListViewModel({
            value: RADApplication.getInstance().templateStyle(),
            data: this.defineComputed(() => {
                return ['W3L_BaseStyle'];
            })
        });

        this.okay = new this.ButtonViewModel({
            isPrimaryButton: true,
            image: new this.ImageViewModel({
                source: GlobalConfiguration.inlineImages.WINDOW_OK,
                alternativeText: new this.LabelViewModel({
                    ergName: 'OKAY'
                })
            }),
            label: new this.LabelViewModel({
                ergName: 'OKAY'
            }),
            onClick: () => {
                let style = this.templateStyle.value();
                RADApplication.getInstance().templateStyle(style);
                this.window.isOpen(false);
            }
        });

        this.cancel = new this.ButtonViewModel({
            image: new this.ImageViewModel({
                source: GlobalConfiguration.inlineImages.WINDOW_CANCEL,
                alternativeText: new this.LabelViewModel({
                    ergName: 'CANCEL'
                })
            }),
            label: new this.LabelViewModel({
                ergName: 'CANCEL'
            }),
            onClick: () => {
                this.window.isOpen(false);
            }
        });
    }
}

ComponentManager.setViewModel('TemplateStyleViewModel', TemplateStyleViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');